import { useTranslation } from 'next-i18next';
import { DSButton, DSHeading, DSText } from '@stihl-design-system/components';

import { RaffleForm } from '@phoenix/team-m/my-tool-shed/frontend/shared/raffle/raffle-form';
import { Steps } from './raffle';

export const RaffleSteps = ({
  id,
  headline,
  description,
  afterSubmissionResponse,
  questions,
  currentStep,
  setNextStep,
  enterRaffle,
  isSubmitting,
  participationSuccess,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {currentStep === Steps.PARTICIPATION && (
        <div className="flex-1 self-center text-center tablet:text-start px-4 tablet:px-6 pt-9 pb-6 desktop:pl-10 desktop:pr-12">
          <DSHeading size="large-uppercase" className="text-wrap">
            {headline}
          </DSHeading>
          <DSText className="mt-2">{description}</DSText>
          <DSButton onClick={setNextStep} className="mt-5 w-full tablet:w-fit">
            {t('toolShed_myEquipment_raffle_buttonParticipate')}
          </DSButton>
        </div>
      )}
      {currentStep === Steps.TERMS_CONDITIONS && (
        <RaffleForm
          className="flex-1 self-stretch pt-9 tablet:pt-6"
          raffleId={id}
          enterRaffle={enterRaffle}
          isSubmitting={isSubmitting}
          questions={questions}
        />
      )}
      {currentStep === Steps.AFTER_SUBMISSION && (
        <div className="flex-1 self-center text-center tablet:text-start px-4 tablet:px-6 pt-9 pb-6 desktop:pl-10 desktop:pr-12">
          <DSHeading size="large-uppercase" className="text-wrap">
            {t(participationSuccess ? 'toolShed_myEquipment_raffle_headerStep3' : 'toolShed_myEquipment_raffle_headerErrorStep3')}
          </DSHeading>
          <DSText className="mt-2">
            {t(
              participationSuccess
                ? afterSubmissionResponse ?? 'toolShed_myEquipment_raffle_descriptionStep3'
                : 'toolShed_myEquipment_raffle_descriptionErrorStep3'
            )}
          </DSText>
        </div>
      )}
    </>
  );
};
